<template>
    <be-loading :active="loading">

        <div class="email-head">
            <div class="email-head-title">Passwort ändern<span class="icon mdi mdi-plus-box"></span></div>
        </div>

        <form @submit.prevent="submit">
            <div class="email-compose-fields">
                <text-field horizontal disabled label="Vorname" :value="user.firstname"/>
                <text-field horizontal disabled label="Nachname" :value="user.lastname"/>
                <text-field horizontal disabled label="E-Mail Adresse" :value="user.email"/>
                <text-field horizontal label="Passwort" v-model="password" :validation="$v.password"/>
                <text-field horizontal label="Passwort bestätigen" v-model="passwordConfirm" :validation="$v.passwordConfirm"/>
                <be-form-group class="text-right" horizontal>
                    <submit-button h-space>Passwort ändern</submit-button>
                    <submit-button type="button" color="secondary" @click="$router.push({ name: 'admin-users' })">Abbrechen</submit-button>
                </be-form-group>
            </div>
        </form>

    </be-loading>
</template>

<script>
    import { withParams } from 'vuelidate';
    import { required, sameAs } from 'vuelidate/lib/validators';
    import { password } from '../../../../validators';
    import errorHandler from '../../../../mixins/errorHandler';
    import User from '../../../../models/User';

    export default {
        mixins: [errorHandler],

        data: () => ({
            user: {},
            password: '',
            passwordConfirm: '',
            loading: true,
        }),

        validations: {
            password: { required, password },
            passwordConfirm: {
                required,
                password,
                sameAsPassword: withParams({ message: 'Das Passwort stimmt nicht überein.' }, sameAs('password')),
            },
        },

        methods: {
            async submit() {
                this.$v.$touch();

                if (this.$v.$pending || this.$v.$error) {
                    this.$nextTick(() => {
                        this.$scrollTo('.parsley-errors-list', 500, {
                            offset: -200,
                        });
                    });
                    return;
                }

                this.loading = true;

                try {
                    await this.user.sync({ plainPassword: this.password });
                    this.$store.dispatch('notifications/add', {
                        color: 'success',
                        title: 'Passwort geändert!',
                        description: 'Das neue Passwort ist ab sofort gültig.',
                    });
                    this.$router.push({ name: 'admin-users' });
                } catch (err) {
                    this.catchError('Passwort nicht geändert', 'Beim Ändern des Passworts ist ein Fehler aufgetreten.', err);
                } finally {
                    this.loading = false;
                }
            },
        },

        async created() {
            this.loading = true;
            this.user = await User.find(this.$route.params.id);
            this.loading = false;
        },
    };
</script>
